import { LabelS } from '@sorare/core/src/atoms/typography';
import { Chip } from '@sorare/core/src/atoms/ui/Chip';

type Props = { nb: number; max: number };

export const RarityEntries = ({ nb, max }: Props) => {
  return (
    <Chip size="medium" color="yellow">
      <div>
        <LabelS as="span" bold>
          {nb}
        </LabelS>{' '}
        <LabelS as="span" color="var(--c-nd-600)">
          / {max}
        </LabelS>
      </div>
    </Chip>
  );
};
